/**
 * The setup page's map card (first on the page). Boards with their own rules
 * get the shared SpecialRulesCard (components/map) right under it.
 */
import React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import type { MapDef } from '@warcarp/api-types'
import { MapThumbnail } from '../../map/MapThumbnail'
import { hasSpecialRules, mapFacts } from '../../../lib/gameSetupDraft'

export function SetupMapCard({ mapId, mapName, map, wide, edit, thumbWidth, onChangeMap }: {
  mapId: string
  mapName: string
  map: MapDef | null | undefined
  /** Desktop/tablet: thumbnail beside the details. Phone: a banner above them. */
  wide: boolean
  edit: boolean
  /** Phone banner width (the card's inner width). */
  thumbWidth: number
  onChangeMap: () => void
}) {
  const star = hasSpecialRules(map) ? ' ★' : ''
  const facts = map ? mapFacts(map) : ''
  const change = (label: string) => <TouchableOpacity onPress={onChangeMap} accessibilityRole="button" accessibilityLabel="Change map"
    testID="map-picker-trigger" className="rounded-md border-2 border-olive bg-paper-up" style={{ paddingHorizontal: 10, paddingVertical: 5, alignSelf: wide ? 'flex-start' : 'center' }}>
    <Text className="font-typed text-ink text-sm">{label}</Text>
  </TouchableOpacity>
  if (wide) {
    return <View testID="setup-map-card" className="bg-paper border-2 border-olive rounded-xl flex-row items-center"
      style={{ padding: 12, paddingHorizontal: 14, gap: 16 }}>
      <MapThumbnail mapId={mapId} width={210} height={104} />
      <View style={{ flex: 1, minWidth: 0, gap: 4 }}>
        <Text className="font-stencil text-[10px] uppercase tracking-widest text-olive-up">Map</Text>
        <Text className="font-stencil text-ink" style={{ fontSize: 18 }} numberOfLines={1}>{mapName}{star}</Text>
        <Text className="font-typed text-ink-soft text-xs">{facts}{edit && facts ? ' · Seats are kept if you change the map' : ''}</Text>
        <View style={{ marginTop: 6 }}>{change('Change map ›')}</View>
      </View>
    </View>
  }
  return <View testID="setup-map-card" className="bg-paper border-2 border-olive rounded-xl" style={{ overflow: 'hidden' }}>
    <MapThumbnail mapId={mapId} width={thumbWidth} height={120} />
    <View className="flex-row items-center" style={{ gap: 10, paddingHorizontal: 14, paddingVertical: 12 }}>
      <View style={{ flex: 1, minWidth: 0, gap: 2 }}>
        <Text className="font-stencil text-ink" style={{ fontSize: 18 }} numberOfLines={1}>{mapName}{star}</Text>
        <Text className="font-typed text-ink-soft text-xs">{facts}</Text>
        {edit && <Text className="font-typed text-ink-soft text-xs">Seats are kept if you change the map</Text>}
      </View>
      {change('Change ›')}
    </View>
  </View>
}
